export const dataHooks = {
  heading: 'heading',
  renamingField: 'renaming-field',
};
